<!-- Field Template -->
<ng-template #field_template>
  <div class="field">
    <ng-container *ngTemplateOutlet="input_template"></ng-container>
  </div>
</ng-template>


<!-- Editor Template -->
<ng-template #editor_template>
  <editor #editor
    class="w-full"
    [class.h-full]="fullHeight"
    [class.pointer-events-none]="(slideAuthorFacade.isSplitterMoving$ | async)"
    [attr.aria-labelledby]="name + '_label'"
    [formControlName]="name"
    outputFormat="html"
    modelEvents="change input nodechange undo redo"
    [init]="initalSettings">
  </editor>
</ng-template>


<!-- In Place Template -->
<ng-template #inplace_template>
  <p-inplace
    styleClass="w-full h-full editor-inplace"
    [active]="active()"
    [closable]="true"
    (onDeactivate)="hanldeInPlaceDeactivate()"
    (onActivate)="handleInPlaceActivate()">
    <ng-template pTemplate="display">
      <div #display
        class="flex flex-1 flex-column w-full h-full p-inputtext p-component p-element overflow-auto text-format-body"
        [class.editor-placeholder]="!control?.value && placeholder"
      [innerHTML]="(control?.value || ((placeholder || '') | translate)) | safeHtml"></div>
    </ng-template>
    <ng-template pTemplate="content">
      @if (active()) {
        <ng-container *ngTemplateOutlet="editor_template"></ng-container>
      }
    </ng-template>
  </p-inplace>
</ng-template>


<!-- Input Template -->
<ng-template #input_template>
  @if (label) {
    <label
      [id]="name + '_label'"
      class="flex flex-grow-1"
      [for]="name">
      <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
        {{ label | translate }}
      </span>
    </label>
  }
  @if (inPlace) {
    <ng-container *ngTemplateOutlet="inplace_template"></ng-container>
  } @else {
    <ng-container *ngTemplateOutlet="editor_template"></ng-container>
  }
  @if (control !== undefined && control.touched && control.errors && control.errors.length > 0) {
    <br/>
    @for (err of control.errors | keyvalue; track err) {
      <small [id]="name + '_help'"
        class="p-error">
        {{ err.value | translate }}
      </small>
      <br/>
    }
  }
</ng-template>


<!-- Text Area Input -->
@if (name) {
  @if (formField) {
    <ng-container *ngTemplateOutlet="field_template"></ng-container>
  } @else {
    <ng-container *ngTemplateOutlet="input_template"></ng-container>
  }
}